import { IDeleteFornecedorBancoUseCase } from "../../../presentation/useCases/delete/delete_fornecedor_banco_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * DeleteFornecedorBancoUseCase
 */

export class DeleteFornecedorBancoUseCase implements IDeleteFornecedorBancoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async deleteFornecedorBanco(
    idFornecedor: number,
    idBanco: number,
  ): Promise<void> {
    await this.repository.deleteFornecedorBanco(
      idFornecedor,
      idBanco,
    );
  }
}
